import { render, staticRenderFns } from "./FreeDashboard.vue?vue&type=template&id=718b4c5d&"
import script from "./FreeDashboard.vue?vue&type=script&lang=js&"
export * from "./FreeDashboard.vue?vue&type=script&lang=js&"
import style0 from "./FreeDashboard.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VChip } from 'vuetify/lib/components/VChip';
import { VProgressCircular } from 'vuetify/lib/components/VProgressCircular';
import { VRow } from 'vuetify/lib/components/VGrid';
installComponents(component, {VChip,VProgressCircular,VRow})
